import { useEffect } from "react";
import { useLanguage } from "@/lib/i18n";
import { useLandingConfig } from "./LandingContext";
import {
  applyPageSeo,
  upsertJsonLd,
  organizationLd,
  mobileAppLd,
  faqLd,
  webPageLd,
  breadcrumbLd,
  SITE_URL,
  OG_DEFAULT,
} from "@/lib/seo";

/**
 * Runtime <head> for a Meta-ads landing page. Paths and copy come from the
 * landing config. Uses the same data-seo-id values as the build-time prerender
 * (src/lib/seo-head.ts) so hydration replaces the prerendered tags instead of
 * duplicating them.
 */
export function ParentsLandingSEO() {
  const { language } = useLanguage();
  const { copy: copyByLang, frPath: FR_PATH, enPath: EN_PATH } = useLandingConfig();

  useEffect(() => {
    const copy = copyByLang[language];
    const path = language === "fr" ? FR_PATH : EN_PATH;
    const url = `${SITE_URL}${path}`;

    applyPageSeo({
      lang: language,
      title: copy.meta.title,
      description: copy.meta.description,
      path,
      frPath: FR_PATH,
      enPath: EN_PATH,
      ogImage: OG_DEFAULT,
      ogType: "website",
    });

    upsertJsonLd("landing-organization", organizationLd());
    upsertJsonLd("landing-app", mobileAppLd(language, copy.meta.description));
    upsertJsonLd("landing-faq", faqLd(copy.faq.items, `${url}#faq`));
    upsertJsonLd(
      "landing-webpage",
      webPageLd({ lang: language, url, title: copy.meta.title, description: copy.meta.description }),
    );
    upsertJsonLd(
      "landing-breadcrumb",
      breadcrumbLd([{ name: copy.hero.title, url }]),
    );
  }, [language, copyByLang, FR_PATH, EN_PATH]);

  return null;
}
